import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "layoutType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Modal, ModalCustom } from '@snack-uikit/modal';
import { MobileModal } from '../MobileModal';
import { MobileModalCustom } from '../MobileModalCustom';
import { jsx as _jsx } from "react/jsx-runtime";
export function AdaptiveModal(_ref) {
  var size = _ref.size,
    layoutType = _ref.layoutType,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMobile = layoutType === 'mobile';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return isMobile ? /*#__PURE__*/_jsx(MobileModal, _objectSpread({}, props)) : /*#__PURE__*/_jsx(Modal, _objectSpread(_objectSpread({}, props), {}, {
    size: size
  }));
}
export function useAdaptiveModalCustom(_ref2) {
  var layoutType = _ref2.layoutType;
  var isMobile = layoutType === 'mobile';
  return isMobile ? MobileModalCustom : ModalCustom;
}